export default {
  methods: {
    getRandomGif( tag = 'motivation' ) {

      const API_KEY = 'zrz5iPBOZinhBBaXSYGlJKIXmcXmGBe8'

      let url = `https://api.giphy.com/v1/gifs/random?api_key=${API_KEY}&tag=${tag}&rating=G`

      return fetch(url)
      .then(response => response.json())
      .then(data => {
        console.log( "[Giphy] Got data from API", data)

        if ( data.meta.msg === 'OK' ) {
          return data.data.image_url
        }
        return null
      })
    }
  }
}
